var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiper",staticClass:"swiper-container",class:{
  isClosed: !_vm.isOpened,
  isOpened: _vm.isOpened,
  isMoving: _vm.isMoving,
  isMobile: _vm.isMobile
},on:{"!click":function($event){return _vm.maybePrevent($event)},"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onMousedown($event)},"touchstart":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onMousedown($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }